import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import CondensedListItem from '../../../../../list-items/CondensedListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const LyricsPositionListItem = (props) => {
    const { lyricsPositionX, lyricsPositionY, index, updateLyricsStyle, maxXPosition, maxYPosition } = props;

    const onPositionXChange = (value) => {
        previewHistoryBatch.start();

        updateLyricsStyle({
            position: { x: value }
        });
    };

    const onPositionYChange = (value) => {
        previewHistoryBatch.start();

        updateLyricsStyle({
            position: { y: value }
        })
    };
    
    return (
        <CondensedListItem 
            elements={[
                {
                    width: 6,
                    component: <SliderListItem
                        title='X Position'
                        value={lyricsPositionX}
                        displayMultiplier={1}
                        min={-maxXPosition}
                        max={maxXPosition}
                        step={1}
                        onValueChange={onPositionXChange}
                        onSliderChangeCommitted={() => previewHistoryBatch.end()}
                        onInputFocusIn={() => previewHistoryBatch.start()}
                        onInputFocusOut={() => previewHistoryBatch.end()}
                    />
                },
                {
                    width: 6,
                    component: <SliderListItem
                        title='Y Position'
                        value={lyricsPositionY}
                        displayMultiplier={-1}
                        min={-maxYPosition}
                        max={maxYPosition}
                        step={1}
                        onValueChange={onPositionYChange}
                        onSliderChangeCommitted={() => previewHistoryBatch.end()}
                        onInputFocusIn={() => previewHistoryBatch.start()}
                        onInputFocusOut={() => previewHistoryBatch.end()}
                    />
                }
            ]}
        />
    );
};

const mapStateToProps = (state) => {
    const { 
        x: lyricsPositionX, 
        y: lyricsPositionY, 
    } = state.createPreview.present.videoSettings.lyrics.style.position;

    const { maxXPosition, maxYPosition } = state.create.maxValues;

    return { 
        lyricsPositionX,
        lyricsPositionY,
        maxXPosition,
        maxYPosition
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (index, properties) => dispatch(createActions.updateLyricsStyle(index, properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsPositionListItem);